import React from 'react';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'cyan' | 'navy' | 'gold' | 'slate' | 'lime' | 'graphite' | 'paper' | 'actual' | 'simulation' | 'planning' | 'available';
  size?: 'sm' | 'md';
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'cyan',
  size = 'md',
  className = '',
}) => {
  const sizeClasses = size === 'sm' ? 'px-2.5 py-0.5 text-xs' : 'px-3 py-1 text-xs';

  let variantClasses = '';
  switch (variant) {
    case 'cyan':
    case 'lime':
    case 'available':
      variantClasses = 'bg-spaq-cyan-pale text-spaq-cyan-dark font-semibold border border-spaq-cyan/30';
      break;
    case 'navy':
    case 'actual':
      variantClasses = 'bg-navy/10 text-navy font-semibold border border-navy/20';
      break;
    case 'gold':
    case 'planning':
    case 'simulation':
      variantClasses = 'bg-spaq-gold-pale text-spaq-gold-dark font-semibold border border-spaq-gold/40';
      break;
    case 'paper':
    case 'slate':
    default:
      variantClasses = 'bg-surface-slate text-navy-muted font-medium border border-surface-border';
      break;
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ${sizeClasses} ${variantClasses} ${className}`}
    >
      {children}
    </span>
  );
};
